import httpService from 'services/httpService';
import { getQuery } from './utils';

export const VIDEO_API_URL = 'api/video-api';

export enum DiscussionsSortOrder {
  Ascending = 'ascending',
  Descending = 'descending',
}

export const standaloneFetcher = <T = unknown>(url: string) =>
  httpService.get<T>({ url, config: { baseURL: '/o' } }).then(res => res.data);

export const completeRtmpStream = (eventiId: string, sessionId: string) =>
  httpService
    .post({ url: `api/v3/standalone/events/${eventiId}/sessions/${sessionId}/streams/complete` })
    .then(response => response.data);

export const getRtmpSessionDiscussionsEndpoint = (
  sessionId: string,
  args: {
    sort_order: DiscussionsSortOrder;
    limit: number;
    offset: number;
  },
) => `api/v3/discovery/sessions/${sessionId}/hybrid/discussions${getQuery(args)}`;
export const postRtmpDiscussions = (
  sessionId: string,
  payload: {
    content: string;
    session: string;
    parent?: string;
    raw_content: string;
    mentions: string[];
  },
) =>
  httpService
    .post<MorressierDiscussion>({
      url: `api/v3/discovery/sessions/${sessionId}/hybrid/discussions`,
      data: payload,
    })
    .then(response => response.data);

export const updateRtmpDiscussions = (
  sessionId: string,
  payload: {
    content: string;
    raw_content: string;
    mentions: string[];
  },
  discussionId: string,
) =>
  httpService
    .patch<MorressierDiscussion>({
      url: `api/v3/discovery/sessions/${sessionId}/hybrid/discussions/${discussionId}`,
      data: payload,
    })
    .then(response => response.data);

export const approveRtmpDiscussion = (sessionId: string, discussionId: string) =>
  httpService
    .put({
      url: `api/v3/discovery/sessions/${sessionId}/hybrid/discussions/${discussionId}/approve`,
    })
    .then(response => response.data);

export const deleteRtmpDiscussion = (sessionId: string, discussionId: string) =>
  httpService
    .delete({ url: `api/v3/discovery/sessions/${sessionId}/hybrid/discussions/${discussionId}` })
    .then(response => response.data);
